import { downloadReviewDelivery } from '../lib/review-delivery.js';

export function ReviewDeliveryControl({ jobId, ready, revisionDigest }) {
  const [state, setState] = React.useState({});
  const current = React.useRef(null);
  const identity = jobId + ':' + revisionDigest;
  if (current.current?.identity !== identity || current.current?.ready !== ready) {
    current.current = { identity, ready, request: null };
  }
  const frame = current.current;
  React.useEffect(() => () => { current.current = null; }, []);
  if (!ready) return null;
  const local = state.frame === frame ? state : {};
  const download = async () => {
    if (!frame.ready || current.current !== frame || frame.request) return;
    const request = {};
    frame.request = request;
    const isCurrent = () => current.current === frame && frame.request === request;
    setState({ frame, busy: true });
    try {
      await downloadReviewDelivery(jobId, { isCurrent });
      if (isCurrent()) setState({ frame });
    } catch (error) {
      if (isCurrent()) setState({ frame, error: error.message });
    } finally {
      if (frame.request === request) frame.request = null;
    }
  };
  return <span className="w-delivery-control">
    <button className="btn btn-primary btn-sm" data-action="download-delivery" disabled={!!local.busy} onClick={download}>
      {local.busy ? 'Downloading…' : 'Download delivery ZIP'}
    </button>
    {local.error && <span className="w-review-error" role="alert">{local.error}</span>}
  </span>;
}
